'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const SessionExpiredError=require('../../../dist-es6/client/services/errors/sessionExpiredError');
const AccessDeniedError=require('../../../dist-es6/client/services/errors/accessDeniedError');
const AppReloadRequiredError=require('../../../dist-es6/client/services/errors/appReloadRequiredError');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');let

HandleUncaughtErrorsAnnotation=class HandleUncaughtErrorsAnnotation{
constructor(errorToResult=_.noop){
this._errorToResult=errorToResult;
}

get errorToResult(){
return this._errorToResult;
}};let


UncaughtErrorHandler=class UncaughtErrorHandler extends BaseService{
static get $inject(){
return['errorHandlers'];
}

constructor(errorHandlers){
super();
this._errorHandlers=errorHandlers;
}

_wrap(instance,asyncAction,errorToResult){
return async(...args)=>{
try{
return await asyncAction.apply(instance,args);
}catch(e){
const handler=this._errorHandlers.handlerFor(e);
if(_.exists(handler)){
handler(e);
return errorToResult(e);
}
throw e;
}
};
}

applyTo(instance){
const prototype=instance.constructor.prototype;
const propertyNames=Object.getOwnPropertyNames(prototype);
for(const propertyName of propertyNames){
if(_.attempt(()=>prototype[propertyName])instanceof Error||
typeof prototype[propertyName]!='function'){
continue;
}

const propertyAnnotations=tryGet(prototype,`["${propertyName}"].annotations`).otherwise([]);
const relevantAnnotation=_.find(propertyAnnotations,annotation=>annotation instanceof HandleUncaughtErrorsAnnotation);
if(_.exists(relevantAnnotation)){
instance[propertyName]=this._wrap(instance,instance[propertyName],relevantAnnotation.errorToResult);
}
}
}};


module.exports=UncaughtErrorHandler;
module.exports.Annotations={
HandleUncaughtErrors:function(_potentialErrorToResultOrTarget,undefinedOrKey,undefinedOrDescriptor){
if(arguments.length===3){


const descriptor=undefinedOrDescriptor;

const annotation=new HandleUncaughtErrorsAnnotation;
descriptor.value.annotations=_addAnnotation(descriptor,annotation);
descriptor.kind='method';

return descriptor;
}else{
return(target,key,descriptor)=>{
const annotation=new HandleUncaughtErrorsAnnotation(_potentialErrorToResultOrTarget);
descriptor.value.annotations=_addAnnotation(descriptor,annotation);
descriptor.kind='method';

return descriptor;
};
}

}};


function _addAnnotation(descriptor,annotation){
return tryGet(descriptor,'value.annotations').
then(a=>a.push(annotation)).
otherwise([annotation]);
}
//# sourceMappingURL=uncaughtErrorHandler.js.map
